import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { loginVerifyPasswordApi, LoginVerifyPasswordType } from '@/api/v1/users/loginVerifyPasswordApi';

export const loginVerifyPassword = async (payload: LoginVerifyPasswordType) => {
  try {
    const response = await loginVerifyPasswordApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
